import React, { useEffect, useState } from 'react'
import "./css/style.css";
const Tempapp = () => {
  
    const [city, setCity] = useState(null);
    const [search, setSearch] = useState("Layyah");
    useEffect( () => {
        const fetchApi = async() =>{
            const url = `https://api.openweathermap.org/data/2.5/weather?q=${search}&units=metric&appid=ee7a77c8be71b199230d48be9006e14d`;
            const response = await fetch(url);
            const resJson = await response.json();
            // console.log(resJson);
            setCity(resJson.main);
        }
        fetchApi ();
    },[search])
  return (
      <>
    <div className ='box'>
      <div className ='inputData'>
          <input type="search"
          value={search}
           className ='inputFeild'
           onChange={ (event) =>{ setSearch(event.target.value) } } />
       </div>

       {!city ? (
         <p className='errorMsg'>No Data Found</p>
       ) : (
           <div>
              <div className ='info'>
                <h2 className ='location'>
                  <i className ="fas fa-street-view"></i>{search}
                </h2>
                <h1 className ='temp'>
                  {city.temp}°Cel
                </h1>
                <h3 className ='tempmin-max'>{city.temp_min}°Cel | {city.temp_max}°Cel</h3>
             </div>
             <div className ='wave -one'></div>
             <div className ='wave -two'></div>
             <div className ='wave -three'></div>
             <p>Designed By Shazina Razia</p>
           </div>
       )}
       
        </div>
    </>
  )
}

export default Tempapp
